export default __webpack_public_path__ + "static/media/reassign.10537c78.svg";